import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import NetaqInput from '../components/NetaqInput'
import ActionButton from '../components/ActionButton'
import { ToastContainer, toast } from 'react-toastify';
import axios from '../axios/axios';
import axiosUmbraco from "../axios/axiosUmbraco";
import { useTranslate } from '../components/TranslationText';
import { useSelector } from 'react-redux';
import Loader from '../components/Loader';
import ReCAPTCHA from 'react-google-recaptcha';
import SubmitBtn from '../components/SubmitBtn';
import PillBtn from '../components/PillBtn';
import EahsForm from '../components/EahsForm';
import NewActionButton from '../components/ActionButtons/NewActionButton';
import { updateHeadTags } from '../helper/updateHeadTags';
import { isProduction } from '../helper/isProduction';

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function ContactUs() {
    // umbraco
    const MediaBaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;
    const FooterID = process.env.REACT_APP_HOME_PAGE_FOOTER_ID;

    const ContactUsID = process.env.REACT_APP_CONTANCT_US_ID
    const { translate } = useTranslate();

    const { currentLanguage } = useSelector(
        (state) => state.studBookSlice
    );
    const [contactus, setContactus] = useState([]);
    const [loaded, setloaded] = useState(false);


    const id = ContactUsID;
    const recaptchaRef = useRef();
    const [recaptchaToken, setRecaptchaToken] = useState(isProduction ? "" : null);
    const [recaptchaValidate, setRecaptchaVaidate] = useState(!isProduction);


    function getCurrentLanguageUmbraco() {
        // Replace this with your logic to retrieve the current language
        // For example, you can retrieve it from localStorage or from a state variable
        const lang = localStorage.getItem("eahsLang") ?? "en";
        if (lang == "en") return 'en-US';
        else return 'ar-AE'; // Defaulting to English for demonstration
    }


    useEffect(() => {
        async function getdata() {
            const umbraco = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item?id=${id}`, {
                headers: {
                    "accept-language": getCurrentLanguageUmbraco(),

                }
            })
            const footer = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item?id=${FooterID}`, {
                headers: {
                    "accept-language": getCurrentLanguageUmbraco(),
                }
            })
            const formattedData = umbraco.data?.map((item) => ({
                contactWhatsApp: item?.properties?.contactWhatsApp ?? '',
                contactTitle: item?.properties?.contactTitle ?? '',
                contactPhone: item?.properties?.contactPhone ?? '',
                contactMapUrl: item?.properties?.contactMapUrl ?? '',
                contactEmail: item?.properties?.contactEmail ?? '',
                contactDescription: item?.properties?.contactDescription ?? '',
                contactAddress: item?.properties?.contactAddress ?? '',
                seoTitle: item?.properties?.seoTitle ?? '',
                seoDescription: item?.properties?.seoDescription ?? '',
                seoKeywords: item?.properties?.seoKeywords ?? []

            }));
            const footerData = footer.data?.map((item) => ({
                workingHours: item?.properties?.workingHours?.markup ?? '',
                facebookURL: item?.properties?.socialMedia[0]?.url ?? '',
                xtwitterURL: item?.properties?.socialMedia[1]?.url ?? '',
                instaURL: item?.properties?.socialMedia[2]?.url ?? '',
                youtubeURL: item?.properties?.socialMedia[3]?.url ?? '',
                PinterestURL: item?.properties?.socialMedia[4]?.url ?? '',
                tiktokURL: item?.properties?.socialMedia[5]?.url ?? '',
                auctionMobileGoogleplayLink: item?.properties?.auctionAppGooglePlay ?? '',
                auctionMobileAppleStoreLink: item?.properties?.auctionAppAppleStore ?? '',
                ownerMobileGoogleplayLink: item?.properties?.ownersAppGooglePlay ?? '',
                ownerMobileAppleStoreLink: item?.properties?.ownersAppAppleStore ?? '',

            }));
            if (footerData.length > 0) {
                for (const key in footerData[0]) {
                    if (formattedData.length > 0) {
                        formattedData[0][key] = footerData[0][key]
                    }
                }
            }

            setContactus(formattedData);
            if (umbraco.data.length > 0) {
                updateHeadTags({
                    title: formattedData[0]?.seoTitle,
                    description: formattedData[0]?.seoDescription,
                    keywords: formattedData[0]?.seoKeywords
                });
                setloaded(true);

            }
        }
        getdata();


    }, [currentLanguage]);

    useEffect(() => {
        if (isProduction && recaptchaRef.current) {
            const timer = setTimeout(() => {
                recaptchaRef.current.execute();
            }, 2000); // 1000 milliseconds = 1 second

            // Cleanup the timer if the component is unmounted
            return () => clearTimeout(timer);
        }
    }, []);

    // end of umbraco
    const [contactDetails, setContactDetails] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (event) => {
        setContactDetails({
            ...contactDetails,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const fields = ['name', 'email', 'subject', 'phone', 'message']; // Add more fields as needed
        const emptyFields = fields.filter(field => !contactDetails[field]);
        setIsLoading(true);
        if (emptyFields.length > 0) {
            // Notify the user that some fields are empty
            toast.error(`${translate('web.pleaseFillInTheAllfields', 'Please fill in the All fields')}: ${emptyFields.join(', ').toUpperCase()}`);
            setIsLoading(false);
            return;
        }
        try {
            const send = await axios.post('/contact/submitemail', {
                ...contactDetails,
                GoogleRecaptchaResponse: isProduction ? recaptchaToken : (recaptchaToken || null)
            })
            // console.log('send is ', send)
            if (send.data.responseCode === '200') {
                toast.success(translate('web.messageSentSuccecfully', 'Message Sent Succecfully'))
                setIsLoading(false);
                setContactDetails({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
            } else {
                toast.error('Message does not Sent Succecfully Check API')
                setIsLoading(false);

            }
        } catch (error) {
            toast.error('Error in try Crash')
            setIsLoading(false);
        }
    };
    const dismissAll = () => toast.dismiss();






    return (
        <> {loaded &&
            <>
                <ToastContainer position="top-right" onClick={dismissAll} theme="colored" autoClose={10000} />
                <>
                    <div className='row  rtl'>
                        {contactus.map((item) => (
                            <>
                                <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                                    <div className='p-main bg-white border-15 p-3 h-100'>
                                        <div className='horseCardTitle mb-form-group'>
                                            {item.contactTitle}
                                        </div>
                                        <div className='horseCardDescription mb-3'>
                                            {item.contactDescription}
                                        </div>
                                        <div className='horseCardDescription'>
                                            <Link to={`mailto:${item.contactEmail}`} className='horseCardDescription'>
                                                <i className="red fa-regular fa-envelope"></i>
                                                <span>{translate('web.email', 'Email')}</span>
                                                <p className="text-lowercase" style={{ textTransform: 'lowercase' }}>{item.contactEmail?.toLowerCase()}</p>
                                            </Link>
                                            <Link to={`tel:${item.contactPhone}`} className='horseCardDescription'>
                                                <i className="red fa-solid fa-phone"></i>
                                                <span>{translate('web.phone', 'Phone')}</span>
                                                <p dir="ltr" style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>{item.contactPhone}</p>
                                            </Link>
                                            <Link to={`https://api.whatsapp.com/send/?phone=${item.contactWhatsApp}`} target="_blank" className='horseCardDescription'>
                                                <i className="fa-brands fa-whatsapp whatsapp-green"></i>
                                                <span>{translate('web.whatsApp', 'WhatsApp')}</span>
                                                <p dir="ltr" style={{ textAlign: currentLanguage === 'ar' ? 'right' : 'left' }}>{item.contactWhatsApp}</p>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                                    <div className='p-main bg-white border-15 p-3 h-100'>
                                        <div className='horseCardTitle mb-form-group'>
                                            <span>
                                                {translate('web.address', 'Address')}
                                            </span>
                                        </div>
                                        <div className='horseCardDescription'>
                                            <div className='horseCardDescription mb-2'>{item.contactAddress}</div>
                                            <div dangerouslySetInnerHTML={{ __html: `<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10880.55723120993!2d54.36395190190899!3d24.48718032014602!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e6666e076cc95%3A0xc338a8b5c9f3925e!2sEmirates%20Arabian%20Horse%20Society!5e0!3m2!1sen!2sae!4v1714571792691!5m2!1sen!2sae" width="100%" height="150" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>` }} />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                                    <div className='p-main bg-white border-15 p-3 h-100'>
                                        <div className='mb-form-group'>
                                            <label className="horseCardTitle mb-form-group">
                                                {translate('web.getOwnersApp', "Get Owners App")}
                                            </label>
                                            <div className='row'>
                                                {item.ownerMobileGoogleplayLink !== '' &&
                                                    <Link to={item.ownerMobileGoogleplayLink} target='_blank' className='col-sm-4 col-6 my-1 storeImageLink'>
                                                        <img src={`${BaseURL}/assets/img/googleplay.png`} alt='googleplay' className='w-100 h-100 ' />
                                                    </Link>
                                                }
                                                {item.ownerMobileAppleStoreLink !== '' &&
                                                    <Link to={item.ownerMobileAppleStoreLink} target='_blank' className='col-sm-4 col-6 my-1 storeImageLink'>
                                                        <img src={`${BaseURL}/assets/img/appstore.png`} alt='appstore' className='w-100 h-100 ' />
                                                    </Link>
                                                }
                                            </div>
                                        </div>
                                        {(!!item.auctionMobileGoogleplayLink && !!item.auctionMobileGoogleplayLink) &&
                                            <div className='mb-form-group'>
                                            <label className="horseCardTitle">
                                                {translate('web.getAuctionApp', "Get Auction App")} 
                                            </label>
                                            <div className='row'>
                                                {!!item.auctionMobileGoogleplayLink &&
                                                    <Link to={item.auctionMobileGoogleplayLink} target='_blank' className='col-sm-4 col-6 my-1 storeImageLink'>
                                                        <img src={`${BaseURL}/assets/img/googleplay.png`} alt='googleplay' className='w-100 h-100 ' />
                                                    </Link>
                                                }
                                                {!!item.auctionMobileGoogleplayLink &&
                                                    <Link to={item.auctionMobileAppleStoreLink} target='_blank' className='col-sm-4 col-6 my-1 storeImageLink'>
                                                        <img src={`${BaseURL}/assets/img/appstore.png`} alt='appstore' className='w-100 h-100 ' />
                                                    </Link>
                                                }
                                            </div>
                                        </div>
                                        }
                                        <div >
                                            <label className='horseCardTitle mt-20'>
                                                {translate('web.socialMedia', "Social Media")}
                                            </label>
                                            <div className='horseCardDescription'>
                                                <div className="row footerSocialRow mt-2">
                                                    {item.facebookURL != "" && item.facebookURL != null && <>
                                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                                            <a href={item.facebookURL} target="_blank">
                                                                <img
                                                                    src={`${BaseURL}/assets/img/facebook.png`}
                                                                    className="soical_media_img"
                                                                    alt="facebook"
                                                                />
                                                            </a>
                                                        </div>
                                                    </>}
                                                    {item.xtwitterURL != "" && item.xtwitterURL != null && <>
                                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                                            <a href={item.xtwitterURL} target="_blank">
                                                                <img
                                                                    className="soical_media_img"
                                                                    src={`${BaseURL}/assets/img/twitter.png`}
                                                                    alt="twitter"
                                                                />
                                                            </a>
                                                        </div>
                                                    </>}
                                                    {item.instaURL != "" && item.instaURL != null && <>
                                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                                            <a href={item.instaURL} target="_blank">
                                                                <img
                                                                    className="soical_media_img"
                                                                    src={`${BaseURL}/assets/img/instagram.png`}
                                                                    alt="instagram"
                                                                />
                                                            </a>
                                                        </div>
                                                    </>}
                                                    {item.youtubeURL != "" && item.youtubeURL != null && <>
                                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                                            <a href={item.youtubeURL} target="_blank">
                                                                <img
                                                                    className="soical_media_img"
                                                                    src={`${BaseURL}/assets/img/youtub.png`}
                                                                    alt="youtube"
                                                                />
                                                            </a>
                                                        </div>
                                                    </>}
                                                    {item.PinterestURL != "" && item.PinterestURL != null &&
                                                        <>
                                                            <div className="col-lg-2 col-md-2 col-sm-2">
                                                                <a href={item.PinterestURL} target="_blank">
                                                                    <img
                                                                        className="soical_media_img"
                                                                        src={`${BaseURL}/assets/img/pintrest.png`}
                                                                        alt="pintrest"
                                                                    />
                                                                </a>
                                                            </div>
                                                        </>}
                                                    {item.tiktokURL != "" && item.tiktokURL != null && <>
                                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                                            <a href={item.tiktokURL} target="_blank">
                                                                <img
                                                                    className="soical_media_img"
                                                                    src={`${BaseURL}/assets/img/tiktok.png`}
                                                                    alt="tiktok"
                                                                />
                                                            </a>
                                                        </div>
                                                    </>}

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <form onSubmit={handleSubmit} className='col-lg-12 col-md-12 col-sm-12 ' style={{ position: 'relative' }}>
                                    <EahsForm key={'Contact Us'}>
                                        <input type='hidden' value={recaptchaToken} name='GoogleRecaptchaResponse' />
                                        <div className='col-sm-6 col-12 mb-form-group'>
                                            <NetaqInput required={true} value={contactDetails.name} onChange={handleChange} name={'name'} label={translate('web.fullName', 'Full Name')} placeholder={translate('web.fullName', 'Full Name')} type={'text'} />
                                        </div>
                                        <div className='col-sm-6 col-12 mb-form-group'>
                                            <NetaqInput required={true} value={contactDetails.email} onChange={handleChange} name={'email'} label={translate('web.email', 'Email')} placeholder={translate('web.email', 'Email')} type={'email'} />
                                        </div>
                                        <div className='col-sm-6 col-12 mb-form-group'>
                                            <NetaqInput required={true} value={contactDetails.phone} onChange={handleChange} name={'phone'} label={translate('web.phone', 'Phone')} placeholder={translate('web.phone', 'Phone')} type={'text'} />
                                        </div>
                                        <div className='col-sm-6 col-12 mb-form-group'>
                                            <NetaqInput required={true} value={contactDetails.subject} onChange={handleChange} name={'subject'} label={translate('web.subject', 'Subject')} placeholder={translate('web.subject', 'Subject')} type={'text'} />
                                        </div>
                                        <div className='col-sm-12 col-12 mb-form-group'>
                                            <NetaqInput required={true} value={contactDetails.message} onChange={handleChange} name={'message'} label={translate('web.message', 'Message')} placeholder={translate('web.message', 'Message')} type={'textarea'} />
                                        </div>
                                        <div className='col-md-2 col-sm-4 col-4 mt-3 text-center ms-auto'>
                                            {isLoading ? <Loader /> :
                                                <NewActionButton isButton classNames='btn-danger' disabled={!recaptchaValidate} type='submit' text={translate('web.submit', 'Submit')} />
                                            }
                                        </div>
                                    </EahsForm>
                                    {isProduction && (
                                        <ReCAPTCHA
                                            sitekey={recaptchaSiteKey}
                                            size="invisible"
                                            ref={recaptchaRef}
                                            onChange={(token) => {
                                                setRecaptchaToken(token);
                                                if (token !== "") {
                                                    setRecaptchaVaidate(true);
                                                }
                                            }}
                                        />
                                    )}
                                </form>
                            </>
                        ))}
                    </div>
                </>
            </>
        }
        </>
    )
}
